module.exports = __webpack_public_path__ + "images/project/type-select-normal-829c066c72c3a89bf1ff01b1cf86e6e3.png";